import styles from './TierCard.module.css';
import { Button } from './Button.jsx';

/**
 * A pricing tier card. Used by both the marketing pricing section and the
 * in-app subscription screen.
 *
 * IMPORTANT: `price` is a display string that must come from
 * GET /api/web/pricing. Never hardcode an amount at a call site — the server is
 * the only source of truth for what anything costs.
 *
 * featured:   gold border + ribbon (the recommended tier)
 * current:    this is the plan the user is already on
 */
export function TierCard({
  name,
  price,
  period = '/mo',
  features = [],
  featured = false,
  ribbon = 'Most popular',
  current = false,
  ctaLabel,
  onCta,
  ctaVariant,
  ctaLoading = false,
  className = '',
}) {
  const variant = ctaVariant || (featured ? 'primary' : 'secondary');

  return (
    <div className={`${styles.tier} ${featured ? styles.featured : ''} ${className}`}>
      {featured && ribbon && <span className={styles.ribbon}>{ribbon}</span>}

      <div className={styles.name}>{name}</div>
      <div className={`${styles.price} mono-num`}>
        {price}
        {period && <span>{period}</span>}
      </div>

      <ul className={styles.features}>
        {features.map((f) => (
          <li key={f}>{f}</li>
        ))}
      </ul>

      <Button
        variant={current ? 'secondary' : variant}
        block
        disabled={current}
        loading={ctaLoading}
        onClick={onCta}
      >
        {ctaLabel}
      </Button>
    </div>
  );
}
